import React from 'react'
import { SUPPORT_MAIL_TO } from '../../constants'
import { BLASTS_FEATURE_NAME } from './blasts-constants'

export const BlastsFeatureUnavailable: React.FC = () => {
  return (
    <div className="analytics-component blasts-analytics-container">
      <div style={{ padding: '40px', textAlign: 'center' }}>
        <h3>{BLASTS_FEATURE_NAME} Feature Access Required</h3>
        <p>
          You don't have access to BLASTS ANALYTICS. Please{' '}
          <a href={`${SUPPORT_MAIL_TO}?subject=Request Access to BLASTS ANALYTICS`}>contact support</a>{' '}
          to enable this feature.
        </p>
      </div>
    </div>
  )
}
